interface RouteDTO {
  path: string
  component: FC
  withSidebar: boolean
  exact?: boolean
}
import { FC } from "react"
import { Routes } from "../routes"

import ProfilePage from "./ProfilePage"

import ReportsPage from "./ReportsPage"
import SettingsPage from "./SettingsPage"

import AdminUsersPage from "./AdminUsersPage"
import AdminOrganizationPage from "./AdminOrganizationPage"
import LoginPage from "./LoginPage"
import RegisterPage from "./RegisterPage"
import ForgotPassword from "../components/Profile/ForgotPassword"
import HomePage from "./HomePage"
import SelectOrganization from "../components/Organizations/SelectOrganization"
import CheckProfilePage from "./CheckProfilePage"
import AdminPage from "./AdminPage/AdminPage"
import ComplainPage from "./ComplainPage"
import ProjectsPage from "./ProjectsPage"
import DashboardPage from "./DashboardPage"
import GeoreferencePage from "./GeoreferencePage"

import LaborAccessRequestExternalPage from "./LaborAccessRequest/LaborAccessRequestExternalPage"
import CreateLaborAccessRequestPage from "./LaborAccessRequest/CreateLaborAccessRequestProviderPage"
import LaborAccessRequestProviderExternalPage from "./LaborAccessRequest/LaborAccessRequestProviderExternalPage"

import OwnerRequestControlPage from "./LaborAccessRequest/OwnerRequestControlPage"
import EmployeeRequestControlPage from "./LaborAccessRequest/EmployeeRequestControlPage"
import RequestControlPage from "./LaborAccessRequest/RequestControlPage"
import RecordPage from "./RecordPage"
import BackgroundCheckPage from "./BackgroundCheck/BackgroundCheckPage"
import BackgroundCheckReportPage from "./BackgroundCheck/BackgroundCheckReportPage"
import BackgroundCheckLanding from "../components/Corporate/BackgroundCheckLanding"
import DataworkerLanding from "../components/Corporate/DataworkerLanding"
import PersonalPage from "./PersonalPage"
import LitigationsPage from "./LitigationsPage"
import IdentitiesPage from "./IdentitiesPage"

const routesWithComponent: RouteDTO[] = [
  {
    path: Routes.Projects.path,
    component: ProjectsPage,
    withSidebar: true,
    exact: true,
  },
  {
    path: Routes.Identities.path,
    component: IdentitiesPage,
    withSidebar: true,
    exact: true,
  },
  {
    path: Routes.Litigations.path,
    component: LitigationsPage,
    withSidebar: true,
    exact: true,
  },
  {
    path: Routes.LaborAccessRequestProviderExternal.path,
    component: LaborAccessRequestProviderExternalPage,
    withSidebar: false,
    exact: true,
  },

  {
    path: Routes.EmployeeRequestControl.path,
    component: EmployeeRequestControlPage,
    withSidebar: true,
    exact: true,
  },

  {
    path: Routes.RequestControl.path,
    component: RequestControlPage,
    withSidebar: true,
    exact: true,
  },
  {
    path: Routes.CreateLaborAccessRequest.path,
    component: CreateLaborAccessRequestPage,
    withSidebar: true,
    exact: true,
  },
  {
    path: Routes.PersonalPage.path,
    component: PersonalPage,
    withSidebar: true,
    exact: true,
  },
  {
    path: Routes.LaborAccessRequestExternal.path,
    component: LaborAccessRequestExternalPage,
    withSidebar: false,
    exact: true,
  },
  {
    path: Routes.OwnerRequestControl.path,
    component: OwnerRequestControlPage,
    withSidebar: true,
    exact: true,
  },
  {
    path: Routes.Georeferences.path,
    component: GeoreferencePage,
    withSidebar: true,
    exact: true,
  },
  {
    path: Routes.DashboardProjectDetails.path,
    component: DashboardPage,
    withSidebar: true,
    exact: true,
  },
  {
    path: Routes.Dashboard.path,
    component: DashboardPage,
    withSidebar: true,
    exact: true,
  },
  {
    path: Routes.Admin.path,
    component: AdminPage,
    withSidebar: true,
    exact: true,
  },
  {
    path: Routes.Home.path,
    component: window.location.href.includes("backgroundcheck") ? BackgroundCheckLanding : window.location.href.includes("dataworker") || window.location.href.includes("localhost") ? DataworkerLanding : HomePage,
    withSidebar: false,
    exact: true,
  },
  {
    path: Routes.Dataworkerhome.path,
    component: HomePage,
    withSidebar: true,
    exact: true,
  },
  {
    path: Routes.Complains.path,
    component: ComplainPage,
    withSidebar: true,
    exact: true,
  },
  {
    path: Routes.CheckProfile.path,
    component: CheckProfilePage,
    withSidebar: true,
    exact: true,
  },
  {
    path: Routes.Profile.path,
    component: ProfilePage,
    withSidebar: true,
    exact: true,
  },

  {
    path: Routes.Reports.path,
    component: ReportsPage,
    withSidebar: true,
    exact: true,
  },

  {
    path: Routes.Settings.path,
    component: SettingsPage,
    withSidebar: true,
    exact: true,
  },

  {
    path: Routes.AdminUsers.path,
    component: AdminUsersPage,
    withSidebar: true,
    exact: true,
  },
  {
    path: Routes.AdminOrganizations.path,
    component: AdminOrganizationPage,
    withSidebar: true,
    exact: true,
  },
  {
    path: Routes.SignIn.path,
    component: LoginPage,
    withSidebar: false,
    exact: true,
  },

  {
    path: Routes.ForgotPassword.path,
    component: ForgotPassword,
    withSidebar: false,
    exact: true,
  },
  {
    path: Routes.Register.path,
    component: RegisterPage,
    withSidebar: false,
    exact: true,
  },

  {
    path: Routes.SelectOrganization.path,
    component: SelectOrganization,
    withSidebar: false,
    exact: true,
  },
  {
    path: Routes.Record.path,
    component: RecordPage,
    withSidebar: false,
    exact: true,
  },

  {
    path: Routes.BackgroundCheckPage.path,
    component: BackgroundCheckPage,
    withSidebar: true,
    exact: true,
  },
  {
    path: Routes.BackgroundCheckLanding.path,
    component: BackgroundCheckLanding,
    withSidebar: false,
    exact: true,
  },
  {
    path: Routes.DataworkerLanding.path,
    component: DataworkerLanding,
    withSidebar: false,
    exact: true,
  },
  {
    path: Routes.BackgroundCheckReport.path,
    component: BackgroundCheckReportPage,
    withSidebar: false,
    exact: true,
  },
]

export default routesWithComponent
